import {
    GET_USER_DETAILS, GET_USER_DETAILS_FAILED,
    LOGIN_USER_FAIL, LOGIN_USER_SUCCESS, 
    LOGOUT_SUCCESS, LOGOUT_FAILURE, 
    UPDATE_PROFILE, UPDATE_PROFILE_FAIL, 
    SEND_SUCCESS_LOGIN_FEEDBACK
} from "../actions";

const INITIAL_STATE = {
    auth: false,
    errorMessage: '',
    errorCode: '',
    holdDevice: 1,
    auth_feedback: [],
    user_details: null,
    sync: {
        ethos: 4,
        aua: 1,
        guidelines: 24,
        core: 24,
        podcasts: 1,
        updateseries: 1
    }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOGIN_USER_FAIL:
            return {
                ...state,
                auth: false,
                errorMessage: action.payload.errorMessage,
                errorCode: action.payload.errorCode
            };
        case LOGIN_USER_SUCCESS:
            return { ...state, auth: true, errorMessage: "", errorCode: "", holdDevice: 1 };
        case SEND_SUCCESS_LOGIN_FEEDBACK:
            return { ...state, auth_feedback: action.payload };
        case LOGOUT_SUCCESS:
            return { 
                ...state, 
                auth: false, 
                errorMessage: "", 
                errorCode: "", 
                holdDevice: 1, 
                auth_feedback: [], 
                user_details: null
            }
        case GET_USER_DETAILS:
            return { ...state, user_details: action.payload };
        case UPDATE_PROFILE:
            return { ...state }

        case GET_USER_DETAILS_FAILED:
        case LOGOUT_FAILURE: 
        case UPDATE_PROFILE_FAIL:
            return { ...state, error: action.payload }
        
        default: 
            return state;
    }
}